var exports = {
  "JG": "milestoneLink__FHrp71",
  "RS": "milestoneTitle__ulEEhd",
  "IY": "truncatedText__luCNcf",
};

module.exports = exports;
